/*
 * @Author: Teemo Ding
 * @Date: 2021-10-18 13:21:38
 * @LastEditTime: 2021-10-18 14:22:54
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/Preview/DiscountButton/index.tsx
 */
import React from 'react';
import { Button } from '@/src/components/Antd';
import styles from './css.module.less';
const DiscountButton = ({
  backgroundColour,
  primaryTextColor,
  outlineColour,
  secondaryTextColor,
}) => {
  return (
    <div className={styles.discountButton}>
      <Button
        style={{
          borderColor: outlineColour,
          color: secondaryTextColor,
        }}>
        取消
      </Button>
      <Button
        style={{
          borderColor: backgroundColour,
          backgroundColor: backgroundColour,
          color: primaryTextColor,
        }}>
        使用
      </Button>
    </div>
  );
};

export default DiscountButton;
